module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-155.4c9149b2.svg";